import React, { useEffect, useState } from "react";
import PageHero from "../components/PageHero";
import api from "../lib/api";

export default function FacultyPage() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/faculty", { params: { active_only: true } }).then((r) => setItems(r.data));
  }, []);

  return (
    <>
      <PageHero path="faculty.hero" kicker="Our Team" title="Meet our world-class faculty" subtitle="German master trainers and seasoned Indian specialists — working together to shape India's industrial future." />
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {items.map((f, i) => (
            <div
              key={f.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl border border-slate-100 tilt-card animate-fade-up"
              style={{ animationDelay: `${i * 0.06}s` }}
            >
              <div className="aspect-square overflow-hidden">
                <img src={f.image_url} alt={f.name} className="w-full h-full object-cover zoom-img" />
              </div>
              <div className="p-5">
                <h3 className="font-bold text-[#0B2A6B] text-lg">{f.name}</h3>
                <p className="text-sm text-yellow-600 font-semibold mb-2">{f.role}</p>
                <p className="text-sm text-slate-600 leading-relaxed">{f.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
